<template>
  <div class="mt-4">
    <div class="login-logo">
      <img src="/resources/logos/BS LOGO_LOGO PLATEADO.png" alt style="width:190px" />
    </div>
    <div class="login-box-body">
      <p class="login-box-msg">Register a New Membership</p>

      <form
        action="../../index.html"
        method="post"
        class="form-element"
        @submit="onSubmit"
      >
        <div class="form-group has-feedback">
          <input
            type="text"
            class="form-control"
            placeholder="Username"
            v-model="model.username"
          />
          <span class="ion ion-person form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback">
          <input
            type="email"
            class="form-control"
            placeholder="Email"
            v-model="model.email"
          />
          <span class="ion ion-email form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback">
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            v-model="model.password"
          />
          <span class="ion ion-locked form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback">
          <input
            type="text"
            class="form-control"
            placeholder="Sponsor"
            v-model="model.parent_uuid"
            :readonly="has_parent"
          />
          <span class="ion ion-log-in form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="checkbox">
              <input type="checkbox" id="basic_checkbox_1" />
              <label for="basic_checkbox_1">
                I agree to the Terms and Conditions
                <router-link to="/tos" class=" text-yellow">
                  (READ)
                </router-link>
              </label>
            </div>
          </div>
          <div class="col-12 text-center">
            <button
              v-if="!loading"
              type="submit"
              class="btn btn-success btn-block margin-top-10"
            >
              SIGN UP
            </button>
            <button
              v-else
              type="submit"
              class="btn btn-success btn-block margin-top-10"
              disabled
            >
              Loading <i class="fa fa-circle-o-notch fa-spin"></i>
            </button>
          </div>
        </div>
      </form>

      <div class="margin-top-20 text-center">
        <p>
          Already have an account?
          <router-link to="/login" class=" m-l-5 text-yellow "
            >Sign In</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "register",
  data() {
    return {
      loading: false,
      has_parent: false,
      model: {
        username: "",
        email: "",
        password: "",
        parent_uuid: "",
      },
    };
  },

  mounted() {
    if (this.$route.params.sponsor) {
      this.model.parent_uuid = this.$route.params.sponsor;
      this.model.left_parent_bak =
        this.$route.params.position === "left" ? true : false;
    }
    this.checkParent();
  },

  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.loading = true;
      this.$http
        .post("/api/v1/client/users", this.model)
        .then((response) => {
          this.$store.commit("setCurrentUser", response.data.user);
          this.$store.commit("setAuthToken", response.data.auth_token);
          this.storeLogin(response.data);
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
    storeLogin(data) {
      let action;
      let firstPage = "/dashboard?auth=true";
      if (data.user.temp_user) firstPage = "/plans";
      action = async () => {
        await router.push(firstPage);
      };
      action();
    },
    checkParent() {
      if (this.model.parent_uuid != undefined) {
        this.has_parent = true;
      }
    },
  },
};
</script>
